window.addEventListener('load', function () {
    if (typeof window.jQuery === 'undefined') return;
    var $ = window.jQuery;
    if (!$.fn.slick) return;

    function isBroken($sliderNav) {
        var active = $sliderNav.find('.slick-active');
        if (!active.length) return true;
        if (!active.find('img').length && !active.is('[data-video],[data-youtube],[data-vimeo],[data-mp4]')) return true;

        var list = $sliderNav.find('.slick-list')[0];
        if (list) {
            var listRect = list.getBoundingClientRect();
            var activeRect = active[0].getBoundingClientRect();
            if (Math.abs(activeRect.x - listRect.x) > 5) return true;
        }
        return false;
    }

    function reinitMainSlider($productView) {
        var sliderNav = $productView.find('.productView-nav');
        if (!sliderNav.length || !sliderNav.hasClass('slick-initialized')) return;
        if (sliderNav.hasClass('productView-nav-gallery') || sliderNav.hasClass('productView-horizontal-tabs')) return;
        if (!isBroken(sliderNav)) return;

        var navArrowsDesk = sliderNav.data('arrows-desk');
        var navArrowsMobi = sliderNav.data('arrows-mobi');

        try {
            sliderNav.slick('unslick');
            sliderNav.find('.slick-counter').remove();
            sliderNav.off('init reInit afterChange beforeChange');
            sliderNav.slick({
                fade: true,
                dots: false,
                arrows: navArrowsDesk,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                nextArrow: window.arrows.icon_next,
                prevArrow: window.arrows.icon_prev,
                rtl: window.rtl_slick,
                responsive: [{ breakpoint: 768, settings: { arrows: navArrowsMobi } }]
            });
        } catch (e) {}
    }

    function reinitMobileThumbnails($productView) {
        var wrapper = $productView.find('.productView-thumbnail-wrapper.is-hidden-mobile');
        if (!wrapper.length || window.innerWidth >= 768) return;
        var sliderFor = wrapper.find('.productView-for');
        if (!sliderFor.length || !sliderFor.hasClass('slick-initialized')) return;
        if (sliderFor[0].getBoundingClientRect().height > 5) return;

        var sliderNav = $productView.find('.productView-nav');
        var thumbnailToShow = parseInt(sliderFor.data('max-thumbnail-to-show')) || 4;

        try {
            sliderFor.slick('unslick');
            sliderFor.off('init reInit afterChange beforeChange');
            sliderFor.slick({
                slidesToShow: thumbnailToShow,
                slidesToScroll: 1,
                asNavFor: sliderNav,
                arrows: true,
                dots: false,
                focusOnSelect: true,
                infinite: true,
                nextArrow: window.arrows.icon_next,
                prevArrow: window.arrows.icon_prev,
                rtl: window.rtl_slick,
                responsive: [
                    { breakpoint: 1600, settings: { slidesToShow: thumbnailToShow > 3 ? thumbnailToShow - 1 : thumbnailToShow, slidesToScroll: 1 } },
                    { breakpoint: 767, settings: { slidesToShow: 3, slidesToScroll: 1 } }
                ]
            });
        } catch (e) {}
    }

    function escapeHtml(s) {
        return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
    }

    function thumbSrc(src) {
        return src.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_medium$1$2');
    }

    function rebuildFullGallery($productView) {
        var sliderNav = $productView.find('.productView-nav');
        if (!sliderNav.length || !sliderNav.hasClass('slick-initialized')) return;
        if (sliderNav.hasClass('productView-nav-gallery') || sliderNav.hasClass('productView-horizontal-tabs')) return;
        if (!$productView.find('[data-filter]').length) return;

        var renderedCount = sliderNav.find('.productView-image').length;
        if (renderedCount > 2) return;

        var handle = $productView.attr('data-product-handle');
        if (!handle || $productView.data('wi-gallery-rebuilt')) return;
        $productView.data('wi-gallery-rebuilt', true);

        $.getJSON('/products/' + handle + '.js').done(function (product) {
            var mediaList = (product.media || []).filter(function (m) { return m.src; });
            if (mediaList.length <= renderedCount) return;

            var navHTML = mediaList.map(function (m, i) {
                var pad = Math.round((m.height / m.width) * 10000) / 100;
                return '<div class="productView-image productView-image-adapt fit-contain" data-index="' + (i + 1) + '">' +
                    '<div class="productView-img-container product-single__media" data-media-id="' + m.id + '" style="padding-bottom:' + pad + '%;">' +
                    '<div class="media"><img src="' + m.src + '" srcset="' + m.src + '" alt="' + escapeHtml(m.alt) + '" width="' + m.width + '" height="' + m.height + '"></div></div></div>';
            }).join('');

            var forHTML = mediaList.map(function (m) {
                var small = thumbSrc(m.src);
                return '<div class="productView-thumbnail" data-media-id="' + m.id + '">' +
                    '<div class="productView-thumbnail-link" data-image="' + m.src + '">' +
                    '<img src="' + small + '" srcset="' + small + '" alt="' + escapeHtml(m.alt) + '"></div></div>';
            }).join('');

            var sliderFor = $productView.find('.productView-for:not(.mobile)');
            var navArrowsDesk = sliderNav.data('arrows-desk');
            var navArrowsMobi = sliderNav.data('arrows-mobi');

            try {
                sliderNav.slick('unslick');
                sliderNav.off('init reInit afterChange beforeChange');
                sliderNav.html(navHTML);
                sliderNav.slick({
                    fade: true,
                    dots: false,
                    arrows: navArrowsDesk,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    nextArrow: window.arrows.icon_next,
                    prevArrow: window.arrows.icon_prev,
                    rtl: window.rtl_slick,
                    responsive: [{ breakpoint: 768, settings: { arrows: navArrowsMobi } }]
                });

                if (sliderFor.length) {
                    var thumbnailToShow = parseInt(sliderFor.data('max-thumbnail-to-show')) || 4;
                    sliderFor.slick('unslick');
                    sliderFor.off('init reInit afterChange beforeChange');
                    sliderFor.html(forHTML);
                    sliderFor.slick({
                        slidesToShow: thumbnailToShow,
                        slidesToScroll: 1,
                        asNavFor: sliderNav,
                        arrows: true,
                        dots: false,
                        focusOnSelect: true,
                        infinite: true,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        rtl: window.rtl_slick,
                        responsive: [
                            { breakpoint: 1600, settings: { slidesToShow: thumbnailToShow > 3 ? thumbnailToShow - 1 : thumbnailToShow, slidesToScroll: 1 } },
                            { breakpoint: 767, settings: { slidesToShow: 3, slidesToScroll: 1 } }
                        ]
                    });
                }
            } catch (e) {}
        });
    }

    function runFix() {
        $('.productView').each(function () {
            var $pv = $(this);
            reinitMainSlider($pv);
            reinitMobileThumbnails($pv);
            rebuildFullGallery($pv);
        });
    }

    runFix();

    var resizeTimer;
    $(window).on('resize.galleryResizeFix', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(runFix, 400);
    });
});
